import e from "react";
import r from "./index210.mjs";
import n from "./index229.mjs";
const a = ({ children: t }) => /* @__PURE__ */ e.createElement("div", { className: n.container }, /* @__PURE__ */ e.createElement(r, null), /* @__PURE__ */ e.createElement("div", { className: n.message }, t)), c = ({ children: t }) => /* @__PURE__ */ e.createElement(a, null, t);
export {
  c as AvailabilityInfo
};
